import React, { useEffect } from 'react';
import { useRoutes } from 'hookrouter';
import MortgageArea from './MortgageArea';
import ErrorPage from 'pages/errorPage';
import SignInPage from 'pages/signInPage';
import SignUpPage from 'pages/signUpPage';
import ForgotCredentialsPage from 'pages/forgotCredentialsPage';
import { withProviders } from 'contexts/withProviders';
import StandardLayout from 'layout/standardLayout';
import OLBArea from './OLBArea';
import { ErrorBoundary } from 'common';

const routes = {
  '/': () => <SignInPage />,
  '/mortgage*': () => <MortgageArea />,
  '/olb*': () => <OLBArea />,
  '/sign-in': () => <SignInPage />,
  '/sign-up': () => <SignUpPage />,
  '/forgot-credentials': () => <ForgotCredentialsPage />,
};

const App = () => {
  const routeResult = useRoutes(routes);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [routeResult]);

  return (
    <StandardLayout>
      <ErrorBoundary>{routeResult || <ErrorPage />}</ErrorBoundary>
    </StandardLayout>
  );
};

export default withProviders(App);
